var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dynamic from 'next/dynamic';
import React from 'react';
var ModalDesktopLazy = dynamic(function () { return import('./ModalDesktop'); });
var ModalMobileLazy = dynamic(function () { return import('./ModalMobile'); });
var Modal = function (props) {
    return (props === null || props === void 0 ? void 0 : props.isMobile) ? (React.createElement(ModalMobileLazy, __assign({}, props),
        " ",
        props.children,
        " ")) : (React.createElement(ModalDesktopLazy, __assign({}, props),
        " ",
        props.children,
        " "));
};
export default Modal;
//# sourceMappingURL=Modal.js.map